<template>
  <page-assess-evidence is-read-only></page-assess-evidence>
</template>

<script>
import PageAssessEvidence from '@/views/EvidenceSubmission/PageAssessEvidence.vue';
export default {
  name: 'PageViewEvidence',

  components: {
    PageAssessEvidence
  }
};
</script>

<style scoped>
/* Your component styles go here */
</style>
